export enum DocumentType {
    REPORT= 0,
    PRESCRIPTION = 1,
    WORKLEAVE = 2,
    CERTIFICATE = 3,
  }

// Document imported by the patient, as returned by GET /documents/customer/all
export interface CustomerDocument {
  id: number
  title: string
  // DocumentsTypeEnum value of the API (report, prescription, picture, ...)
  type: string
  created_at: string
  // null for the account holder, the relative id otherwise
  relative_id: number | null
  mime_type?: string
  // API path of the file, relative to /api
  url: string
  calls?: number[]
}